export default function Manifesto() {
  return (
    <section id="manifesto" data-testid="manifesto-section" className="border-y border-black">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 py-20 md:py-32 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <p className="text-xs uppercase tracking-[0.2em]">Manifesto</p>
          <h2 className="font-display text-4xl md:text-6xl mt-6 leading-[0.95] tracking-[-0.02em]">
            Para quem<br />não se rende.
          </h2>
        </div>
        <div className="md:col-span-8 space-y-6 text-base md:text-lg leading-relaxed">
          <p>
            A gente não nasceu pra ficar na média. Acordar cedo, treinar pesado, cumprir
            prazo, cuidar de quem a gente ama — e ainda querer um pedaço de felicidade no
            fim do dia. <span className="font-medium">Isso não é exagero. É coragem.</span>
          </p>
          <p>
            The Quick Brownie existe pra quem escolhe o caminho difícil sem abrir mão da
            doçura. Brownies densos, úmidos, verdadeiros — sem açúcar, sem glúten e sem
            lactose, com todo o sabor que um brownie de verdade precisa ter.
          </p>
          <p className="font-display text-2xl md:text-3xl tracking-[-0.01em]">
            Comece. Continue. Conquiste. E coma um brownie entre cada vitória.
          </p>
        </div>
      </div>
    </section>
  );
}
